module.exports = __webpack_public_path__ + "static/media/smiley.befe62a6.png";